export default "__VITE_ASSET__BvEUPig4__"